<template>
  <svg
    v-if="!filled"
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.573 21.4879C7.573 21.1472 7.41293 20.8355 7.15854 20.631C4.93167 18.8409 3.53345 16.201 3.53345 13.2656C3.53345 7.92267 8.18632 3.53333 14.0001 3.53333C19.8143 3.53333 24.4668 7.92266 24.4668 13.2656C24.4668 18.6082 19.8143 22.9979 14.0001 22.9979C13.0003 22.9979 12.0335 22.8675 11.1187 22.6249C10.8456 22.5524 10.5482 22.5842 10.2928 22.7294L7.69752 24.2049C7.64197 24.2365 7.573 24.1963 7.573 24.1324V21.4879Z"
      :stroke="color"
    />
    <path
      d="M12.8291 10.463L6.91483 16.725L12.2973 13.7718L15.1096 16.725L20.9904 10.463L15.6677 13.3645L12.8291 10.463Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.073 21.3434C7.073 21.2523 7.03023 21.1666 6.95848 21.1105C4.5591 19.2337 3.03345 16.4157 3.03345 13.2656C3.03345 7.61445 7.94338 3.03333 14.0001 3.03333C20.0572 3.03333 24.9668 7.61445 24.9668 13.2656C24.9668 18.9164 20.0572 23.4979 14.0001 23.4979C12.9135 23.4979 11.8632 23.3503 10.8718 23.076C10.7961 23.055 10.7151 23.0645 10.6468 23.1033L7.50882 24.8873C7.31438 24.9978 7.073 24.8574 7.073 24.6338V21.3434ZM6.91484 16.725L12.8291 10.463L15.6677 13.3645L20.9905 10.463L15.1096 16.725L12.2973 13.7718L6.91484 16.725Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
